// Fetching and formatting for the admin dashboard's usage view.
//
// Authenticated by the dashboard's own session cookie — the usage view is a
// section of the admin dashboard, not a separate app, so it has no login of its
// own.

const API_URL = process.env.REACT_APP_API_URL || "";

export async function fetchUsage(path, days) {
  const query = days ? `?days=${encodeURIComponent(days)}` : "";
  const response = await fetch(`${API_URL}${path}${query}`, { credentials: "include" });
  if (!response.ok) {
    throw new Error(
      response.status === 403
        ? "Kein Zugriff auf die Nutzungsdaten."
        : `Laden fehlgeschlagen (HTTP ${response.status})`,
    );
  }
  return response.json();
}

export function formatDuration(ms) {
  if (ms === null || ms === undefined) return "—";
  const seconds = Math.round(Number(ms) / 1000);
  if (!Number.isFinite(seconds) || seconds <= 0) return "0s";
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
}

export function formatCount(value) {
  return Number(value || 0).toLocaleString("de-DE");
}

/** "vor 5 Minuten" / "vor 3 Stunden" / "vor 2 Tagen", plus the exact moment.
 *
 * Rendered from the offset the device recorded rather than the viewer's own
 * clock, so the time shown is the one the resident experienced. */
export function formatLastInteraction(entry) {
  if (!entry) return { relative: "–", exact: null };

  const at = new Date(entry.at);
  const minutes = Math.max(0, Math.round((Date.now() - at.getTime()) / 60000));

  let relative;
  if (minutes < 1) relative = "gerade eben";
  else if (minutes < 60) relative = `vor ${minutes} Min.`;
  else if (minutes < 60 * 24) {
    const hours = Math.round(minutes / 60);
    relative = `vor ${hours} ${hours === 1 ? "Stunde" : "Std."}`;
  } else {
    const days = Math.round(minutes / (60 * 24));
    relative = `vor ${days} ${days === 1 ? "Tag" : "Tagen"}`;
  }

  const local = new Date(at.getTime() + (entry.tz_offset_minutes || 0) * 60000);
  const pad = (n) => String(n).padStart(2, "0");
  const exact =
    `${pad(local.getUTCDate())}.${pad(local.getUTCMonth() + 1)}.${local.getUTCFullYear()}` +
    ` · ${pad(local.getUTCHours())}:${pad(local.getUTCMinutes())}`;

  return { relative, exact };
}
